// // src/components/ValuesSection.jsx
// import React from "react";
// import { motion } from "framer-motion";
// import { useInView } from "react-intersection-observer";
// import {
//   FaHeart,
//   FaStar,
//   FaHandHoldingHeart,
//   FaClock,
//   FaLeaf,
//   FaGem,
//   FaShieldAlt,
//   FaUsers,
// } from "react-icons/fa";

// const ValuesSection = () => {
//   const [ref, inView] = useInView({
//     triggerOnce: true,
//     threshold: 0.1,
//   });

//   // Core values data
//   const values = [
//     {
//       icon: <FaGem />,
//       title: "Excellence",
//       description:
//         "We strive for perfection in every detail, ensuring our guests experience nothing less than the finest hospitality.",
//       color: "from-amber-400 to-amber-600",
//     },
//     {
//       icon: <FaHeart />,
//       title: "Passion",
//       description:
//         "Our team is driven by a genuine love for hospitality, going above and beyond to create memorable stays.",
//       color: "from-rose-400 to-rose-600",
//     },
//     {
//       icon: <FaShieldAlt />,
//       title: "Integrity",
//       description:
//         "Transparent pricing, honest communication, and ethical practices form the foundation of our service.",
//       color: "from-blue-400 to-blue-600",
//     },
//     {
//       icon: <FaUsers />,
//       title: "Community",
//       description:
//         "We foster a warm, inclusive environment where guests feel like family, not just visitors.",
//       color: "from-green-400 to-green-600",
//     },
//     {
//       icon: <FaClock />,
//       title: "Timelessness",
//       description:
//         "Blending modern luxury with classic elegance that never goes out of style.",
//       color: "from-purple-400 to-purple-600",
//     },
//     {
//       icon: <FaLeaf />,
//       title: "Sustainability",
//       description:
//         "Committed to eco-friendly practices that respect our beautiful Islamabad surroundings.",
//       color: "from-emerald-400 to-emerald-600",
//     },
//   ];

//   // Animation variants
//   const containerVariants = {
//     hidden: { opacity: 0 },
//     visible: {
//       opacity: 1,
//       transition: {
//         staggerChildren: 0.15,
//         delayChildren: 0.2,
//       },
//     },
//   };

//   const itemVariants = {
//     hidden: { y: 30, opacity: 0 },
//     visible: {
//       y: 0,
//       opacity: 1,
//       transition: {
//         type: "spring",
//         stiffness: 80,
//         damping: 12,
//         duration: 0.6,
//       },
//     },
//   };

//   return (
//     <section className="py-12 bg-gradient-to-b from-[#f1f1f1] via-[#f1f1f1]/0 to-[#f1f1f1]/0 relative overflow-hidden">

//       <div className="container-custom relative z-10">
//         {/* Section Header */}
//         <motion.div
//           initial={{ opacity: 0, y: 20 }}
//           animate={inView ? { opacity: 1, y: 0 } : {}}
//           transition={{ duration: 0.6 }}
//           className="text-center max-w-3xl mx-auto mb-8 space-y-2"
//         >
//           <div className="flex items-center justify-center gap-3">
//             <div className="w-12 h-[2px] bg-[#c9a86c]"></div>
//             <span className="text-[#c9a86c] font-medium tracking-[0.2em] text-xs uppercase">
//               Our philosophy
//             </span>
//             <div className="w-12 h-[2px] bg-[#c9a86c]"></div>
//           </div>

//           <h2 className="text-4xl md:text-5xl font-light text-[#1a2b3c] leading-tight !mb-4">
//             What We{" "}
//             <span className="font-bold text-[#c9a86c]">Stand For</span>{" "}
//           </h2>

//           <p className="md:text-[17px] 2xl:text-lg text-gray-600 animate-fade-in-up animation-delay-400 leading-relaxed">
//             At StayIN Centaurus, every decision is guided by principles that put
//             our guests first and ensure an unforgettable luxury experience.
//           </p>
//         </motion.div>

//         {/* Values Grid */}
//         <motion.div
//           ref={ref}
//           variants={containerVariants}
//           initial="hidden"
//           animate={inView ? "visible" : "hidden"}
//           className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
//         >
//           {values.map((value, index) => (
//             <motion.div
//               key={index}
//               variants={itemVariants}
//               whileHover={{
//                 y: -8,
//                 transition: { duration: 0.3 },
//               }}
//               className="group p-8 rounded-2xl bg-white shadow-lg hover:shadow-xl transition duration-300 border border-gray-100 hover:border-gray-100"
//             >
//               {/* Background Gradient on Hover */}
//               <div className="flex flex-col items-start">
//                 {/* Icon */}
//                 <div className="w-14 h-14 bg-[#c9a86c]/10 rounded-full flex items-center justify-center mb-4 group-hover:bg-[#c9a86c] transition">
//                   <div className="text-[#c9a86c] text-xl group-hover:text-white transition">
//                     {value.icon}
//                   </div>
//                 </div>

//                 {/* Title */}
//                 <h3 className="text-md font-bold text-[#1a2b3c] mb-3">
//                   {value.title}
//                 </h3>

//                 {/* Description */}
//                 <p className="2xl:text-lg text-gray-600">{value.description}</p>
//               </div>

//               {/* Decorative Corner
//               <div className="absolute bottom-4 right-4 w-16 h-16 opacity-0 group-hover:opacity-10 transition-opacity duration-500">
//                 <div className={`w-full h-full bg-gradient-to-br ${value.color} rounded-full`}></div>
//               </div> */}
//             </motion.div>
//           ))}
//         </motion.div>

//         {/* Bottom Quote */}
//         <motion.div
//           initial={{ opacity: 0, y: 20 }}
//           animate={inView ? { opacity: 1, y: 0 } : {}}
//           transition={{ duration: 0.6, delay: 0.6 }}
//           className="text-center md:mt-12 mt-6"
//         >
         
//             <p className="text-gray-600 text-[17px] 2xl:text-lg">
//               These values aren't just words — they're promises we keep every
//               day.
//             </p>
//         </motion.div>
//       </div>
//     </section>
//   );
// };

// export default ValuesSection;




// src/components/ValuesSection.jsx
import React from "react";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import {
  FaHeart,
  FaStar,
  FaHandHoldingHeart,
  FaClock,
  FaLeaf,
  FaGem,
  FaShieldAlt,
  FaUsers,
} from "react-icons/fa";

const ValuesSection = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  // Core values data
  const values = [
    {
      icon: <FaGem />,
      title: "Excellence",
      description:
        "We strive for perfection in every detail, ensuring our guests experience nothing less than the finest hospitality.",
      keyword: "hospitality excellence"
    },
    {
      icon: <FaHeart />,
      title: "Passion",
      description:
        "Our team is driven by a genuine love for hospitality, going above and beyond to create memorable stays.",
      keyword: "passionate service"
    },
    {
      icon: <FaShieldAlt />,
      title: "Integrity",
      description:
        "Transparent pricing, honest communication, and ethical practices form the foundation of our service.",
      keyword: "transparent hospitality"
    },
    {
      icon: <FaUsers />,
      title: "Community",
      description:
        "We foster a warm, inclusive environment where guests feel like family, not just visitors.",
      keyword: "welcoming community"
    },
    {
      icon: <FaClock />,
      title: "Timelessness",
      description:
        "Blending modern luxury with classic elegance that never goes out of style.",
      keyword: "timeless luxury"
    },
    {
      icon: <FaLeaf />,
      title: "Sustainability",
      description:
        "Committed to eco-friendly practices that respect our beautiful Islamabad surroundings.",
      keyword: "eco-friendly hospitality"
    },
  ];

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 80,
        damping: 12,
        duration: 0.6,
      },
    },
  };

  return (
    <>
      {/* SEO Meta Tags for Values Section */}
      <Helmet>
        <title>Our Values | Excellence, Integrity & Sustainability | StayIN Centaurus Islamabad</title>
        <meta name="description" content="Discover the core values behind StayIN Centaurus: Excellence, Passion, Integrity, Community, Timelessness, and Sustainability. Experience luxury hospitality with purpose in Islamabad." />
        <meta name="keywords" content="StayIN values, hospitality values Islamabad, luxury hotel values, sustainable hospitality, excellence in service, integrity in hospitality, StayIN philosophy" />
      </Helmet>

      {/* Organization Schema with Values */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "StayIN Centaurus Serviced Apartments",
          "description": "Luxury serviced apartments in Centaurus Islamabad guided by principles of Excellence, Passion, Integrity, Community, Timelessness, and Sustainability.",
          "url": "https://stayinhospitality.com/",
          "brand": {
            "@type": "Brand",
            "name": "StayIN Hospitality",
            "slogan": "Where Every Window Tells a Story"
          },
          "makesOffer": {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Luxury Serviced Apartments",
              "description": "Premium serviced apartments with stunning Faisal Mosque views"
            }
          },
          "potentialAction": {
            "@type": "ReserveAction",
            "target": "https://stayinhospitality.com/apartments",
            "name": "Book an Apartment"
          }
        })}
      </script>

      <section 
        className="py-12 bg-gradient-to-b from-[#f1f1f1] via-[#f1f1f1]/0 to-[#f1f1f1]/0 relative overflow-hidden"
        aria-label="Our core values - Excellence, Passion, Integrity, Community, Timelessness, Sustainability"
      >
        <div className="container-custom relative z-10">
          {/* Section Header */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6 }}
            className="text-center max-w-3xl mx-auto mb-8 space-y-2"
          >
            <div className="flex items-center justify-center gap-3">
              <div className="w-12 h-[2px] bg-[#c9a86c]"></div>
              <span className="text-[#c9a86c] font-medium tracking-[0.2em] text-xs uppercase">
                Our philosophy
              </span>
              <div className="w-12 h-[2px] bg-[#c9a86c]"></div>
            </div>

            <h2 className="text-4xl md:text-5xl font-light text-[#1a2b3c] leading-tight !mb-4">
              What We{" "}
              <span className="font-bold text-[#c9a86c]">Stand For</span>{" "}
            </h2>

            <p className="md:text-[17px] 2xl:text-lg text-gray-600 animate-fade-in-up animation-delay-400 leading-relaxed">
              At StayIN Centaurus, every decision is guided by principles that put
              our guests first and ensure an unforgettable luxury experience.
            </p>
          </motion.div>

          {/* Values Grid */}
          <motion.div
            ref={ref}
            variants={containerVariants}
            initial="hidden"
            animate={inView ? "visible" : "hidden"}
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
          >
            {values.map((value, index) => (
              <motion.div
                key={index}
                variants={itemVariants}
                whileHover={{
                  y: -8,
                  transition: { duration: 0.3 },
                }}
                className="group p-8 rounded-2xl bg-white shadow-lg hover:shadow-xl transition duration-300 border border-gray-100 hover:border-gray-100"
              >
                <div className="flex flex-col items-start">
                  {/* Icon */}
                  <div className="w-14 h-14 bg-[#c9a86c]/10 rounded-full flex items-center justify-center mb-4 group-hover:bg-[#c9a86c] transition">
                    <div className="text-[#c9a86c] text-xl group-hover:text-white transition" aria-hidden="true">
                      {value.icon}
                    </div>
                  </div>

                  {/* Title */}
                  <h3 className="text-md font-bold text-[#1a2b3c] mb-3">
                    {value.title}
                  </h3>

                  {/* Description */}
                  <p className="2xl:text-lg text-gray-600">{value.description}</p>
                </div>
              </motion.div>
            ))}
          </motion.div>

          {/* Bottom Quote */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.6 }}
            className="text-center md:mt-12 mt-6"
          >
            <p className="text-gray-600 text-[17px] 2xl:text-lg">
              These values aren't just words — they're promises we keep every
              day.
            </p>
          </motion.div>
        </div>
      </section>
    </>
  );
};

export default ValuesSection;